import { useParams } from "react-router";

import useSessionMetadata from "@app/analytics/MeetingReport/hooks/useSessionMetadata";
import useSessionTags from "@app/common/hooks/tags/useSessionTags";
import useTags from "@app/common/hooks/tags/useTags";

import ManageReportTagsButtonAndPopover from "./ManageReportTagsButtonAndPopover";
import ManageReportTagsDialog from "./ManageReportTagsDialog";

const ManageReportTags = ({
  disabled = false,
  variant,
}: {
  disabled?: boolean;
  variant: "menu" | "dialog";
}) => {
  const { sessionId } = useParams();
  const { tags: allUserTags } = useTags();
  const {
    data: { tags: sessionTags, isRecurringMeeting },
  } = useSessionMetadata();

  const { updateSessionTags } = useSessionTags({
    sessionId: sessionId!,
    sessionTags,
    context: "sessionInfo",
  });

  const Component =
    variant === "menu"
      ? ManageReportTagsButtonAndPopover
      : ManageReportTagsDialog;

  return (
    <Component
      allTags={allUserTags}
      appliedTags={sessionTags}
      canApplyToSeries={isRecurringMeeting}
      disabled={disabled}
      onSave={updateSessionTags}
    />
  );
};

export default ManageReportTags;
